"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _loading = require("@/mixins/loading/loading");

var _report = require("@/api/report.api");

var _elementUi = require("element-ui");

var _moment = _interopRequireDefault(require("moment"));

var _permission = require("@/mixins/permission/permission");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDLoadPlanReportComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDLoadPlanReportComponent, _Mixins);

  var _super = _createSuper(LMDLoadPlanReportComponent);

  function LMDLoadPlanReportComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDLoadPlanReportComponent);
    _this = _super.apply(this, arguments);
    _this.maxDays = 30;
    _this.dateRange = [(0, _moment.default)(new Date()).subtract(_this.maxDays, 'days').format('YYYY-MM-DD'), (0, _moment.default)(new Date()).format('YYYY-MM-DD')];
    _this.reportAPI = null;
    _this.reportData = [];
    _this.selectedProjectCodes = [];
    return _this;
  }

  (0, _createClass2.default)(LMDLoadPlanReportComponent, [{
    key: "created",
    value: function created() {
      if (!this.reportAPI) {
        this.reportAPI = new _report.ReportAPI({
          customerKey: this.$userInformation.customerKey || ''
        });
      }
    }
  }, {
    key: "isValidDateRange",
    value: function isValidDateRange(dateRange) {
      var startDate = (0, _moment.default)(dateRange[0]);
      var endDate = (0, _moment.default)(dateRange[1]);

      var duration = _moment.default.duration(endDate.diff(startDate)).asDays();

      if (duration > this.maxDays) {
        var message = {
          title: this.$i18n.t('general.queryExceed1Month'),
          duration: 5000
        };

        _elementUi.Notification.error(message);

        return false;
      }

      return true;
    }
  }, {
    key: "getData",
    value: function () {
      var _getData = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(type) {
        var codes, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isValidDateRange(this.dateRange)) {
                  _context.next = 11;
                  break;
                }

                this.loading = true;
                codes = this.helper.getDates(new Date(this.dateRange[0]), new Date(this.dateRange[1])).map(function (date) {
                  return (0, _moment.default)(date).format('YYYY-MM-DD');
                });
                _context.next = 5;
                return this.reportAPI.getLMDLoadPlanReport({
                  type: type
                }, {
                  code: codes,
                  projectCode: this.selectedProjectCodes,
                  blockProjectCode: this.$userInformation.blockedProjects || []
                });

              case 5:
                res = _context.sent;

                if (res && !res.failed && !this.helper.isUndefined(res.data)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", null);

              case 8:
                if (type === 'data') {
                  this.reportData = res.data;
                  this.logger.info('Load Plan Report', this.reportData);
                }

                if (type === 'xls') {
                  window.location.href = res.data;
                }

                this.loading = false;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getData(_x) {
        return _getData.apply(this, arguments);
      }

      return getData;
    }()
  }, {
    key: "getPlanStatus",
    value: function getPlanStatus(routes) {
      if (this.helper.every(routes, function (route) {
        return route.status === 'unassigned';
      })) {
        return 'Unassigned';
      }

      if (this.helper.some(routes, function (route) {
        return route.status === 'assigned';
      })) {
        return 'Assigned';
      }

      if (this.helper.every(routes, function (route) {
        return route.status === 'completed';
      })) {
        return 'Completed';
      }

      return '';
    }
  }, {
    key: "handleRowClick",
    value: function handleRowClick($event) {
      var table = this.helper.get(this.$refs, 'loadPlanTable', null);

      if (table) {
        table.toggleRowExpansion($event);
      }
    }
  }]);
  return LMDLoadPlanReportComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _helper.HelperMixin, _logger.LoggerMixin, _loading.LoadingMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], LMDLoadPlanReportComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('projectCodes', {
  namespace: 'common'
})], LMDLoadPlanReportComponent.prototype, "$projectCodes", void 0);
LMDLoadPlanReportComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDLoadPlanReportComponent',
  components: {
    'el-date-picker': _elementUi.DatePicker,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-button': _elementUi.Button,
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn
  }
})], LMDLoadPlanReportComponent);
var _default = LMDLoadPlanReportComponent;
exports.default = _default;